import APIController from "./APIController"
const Workspace = () => {
    //Requesthelper
    const { basicRequest, jsonRequest } = APIController()

    const findWorkspaceNear = async (lat, lon, radius = 1.0) => {
        const data = await jsonRequest(`/finder/nearby?lat=${lat}&lon=${lon}&radius=${radius}`);
        return data;
    };

    const getCategories = async(workspaceId) =>{
        const data = await jsonRequest(`/finder/categories/${workspaceId}`);
        return data;
    }

    const getProducts = async(workspaceId) =>{
        const data = await jsonRequest(`/finder/products/${workspaceId}`);
        return data;
    }

    return{
        findWorkspaceNear,
        getCategories,
        getProducts
    }
}
export default Workspace